import "./TrainingOptions.css";
import { FaChalkboardTeacher, FaLaptopCode, FaVideo } from "react-icons/fa";

const TrainingOptions = () => {
  return (
    <section className="training-section">
      <div className="training-wrapper">
        <h2 className="training-heading">
          Training Options at <span>AAPS</span>
        </h2>

        <div className="training-grid">
          <div className="training-card">
            <div className="icon-circle">
              <FaChalkboardTeacher />
            </div>

            <h3>Classroom Training</h3>

            <ul>
              <li>Instructor-led sessions</li>
              <li>Hands-on lab practice</li>
              <li>Peer learning support</li>
              <li>Assignments with guidance</li>
              <li>Instant doubt clarification</li>
            </ul>
          </div>

          <div className="training-card">
            <div className="icon-circle">
              <FaLaptopCode />
            </div>

            <h3>Online Training</h3>

            <ul>
              <li>Live interactive classes</li>
              <li>Flexible schedule</li>
              <li>Learn from anywhere</li>
              <li>Real-time project work</li>
              <li>Mentor assistance</li>
            </ul>
          </div>

          <div className="training-card">
            <div className="icon-circle">
              <FaVideo />
            </div>

            <h3>Video Learning</h3>

            <ul>
              <li>Recorded sessions access</li>
              <li>Self-paced learning</li>
              <li>Lifetime availability</li>
              <li>Practice assignments</li>
              <li>Easy revision support</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrainingOptions;
